<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M5.499,24c-0.2,0-0.389-0.078-0.53-0.22c-0.292-0.292-0.292-0.768,0-1.061L15.689,12L4.969,1.28
		c-0.142-0.141-0.22-0.33-0.22-0.53s0.078-0.389,0.22-0.53C5.11,0.078,5.299,0,5.499,0s0.389,0.078,0.53,0.22l10.72,10.72
		c0.584,0.584,0.585,1.535,0.001,2.119L6.029,23.78C5.888,23.922,5.699,24,5.499,24z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'arrow-right-1',
    },
    name: {
      type: String,
      required: false,
      default: 'ArrowRight1',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>